import React from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import MemberInfoTab from './memberInfoTab';
import MemberCardDataTab from './memberCardDataTab';
import MemberDocumentTab from './memberDocumentTab';
import MemberActionImageTab from './memberActionImageTab';
import { Member, MemberMetaData } from '../../api/models/member';
import { TabPanel } from '../../shared/tabPanel';
import MemberPersonalPageTab from './memberPersonalPageTab';

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export interface MemberTabProps {
    member: Member | undefined,
    actionImage: string | undefined,
    isLoadingCardData: boolean,
    isLoadingInfo: boolean,
    isLoadingDocument: boolean,
    isLoadingAction: boolean,
    onUpdate: () => void,
    onSubmitJerseyNumber: (identifier: string) => void,
    onSubmitBirthDate: (birthdate: string) => void,
    onSubmitPosition: (identifier: string) => void,
    onSubmitTitle: (identifier: string) => void,
    onSubmitMemberName: (firstName: string, lastName: string) => void
    onSubmitMetaData: (metaData: MemberMetaData) => Promise<void>,
    onSubmitChangeAction: (selectedImage: string) => Promise<void>,
    onSubmitChangePersonalPage: (athletePage: string, isPublic: boolean) => Promise<void>
}

export default function MemberTabs(props: MemberTabProps) {
    const [tabValue, setTabValue] = React.useState(0);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const handleMemberNameUpdate = (firstName: string, lastName: string) => {
        props.onSubmitMemberName(firstName, lastName);
    }

    const handleBirthDateUpdate = (birthdate: string) => {
        props.onSubmitBirthDate(birthdate);
    }

    const handleIdentifierUpdate = (identifier: string) => {
        props.onSubmitJerseyNumber(identifier);
    }

    const handlePositionUpdate = (identifier: string) => {
        props.onSubmitPosition(identifier);
    }

    const handleTitleUpdate = (identifier: string) => {
        props.onSubmitTitle(identifier);
    }

    const handleMetaDataUpdate = (metaData: MemberMetaData) => {
        props.onSubmitMetaData(metaData);
    }


    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleChangeTabs} 
                        aria-label="simple tabs example"
                        variant="scrollable" // Enables horizontal scrolling
                        scrollButtons="auto" // Shows scroll buttons when needed
                        >
                        <Tab label="Info" {...a11yProps(0)} />
                        <Tab label="General" {...a11yProps(1)} />
                        <Tab label="Roster" {...a11yProps(2)} />
                        <Tab label="Documents" {...a11yProps(3)} />
                        <Tab label="Personal Page" {...a11yProps(4)} />
                    </Tabs>
                </Box>
                <TabPanel value={tabValue} index={0}>
                    {props.member && <MemberInfoTab />}
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    {props.member && <MemberCardDataTab />}
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    {props.member && <MemberActionImageTab />}
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    {props.member && <MemberDocumentTab member={props.member} />}
                </TabPanel>
                <TabPanel value={tabValue} index={4}>
                    {props.member && <MemberPersonalPageTab />}
                </TabPanel>
            </Grid>
        </Grid>
    )
};
